import React from 'react';
import { NextPageContext } from 'next';
import Article from '../../containers/article';
import pageWrapper from '../../containers/pageWrapper';
import { fetchPodcastByURI } from '../../graphql/podcast';
import FourOhFour from '../404';
import { contentWpToCF } from '../../utils/data/cdn';
import styles from './styles.module.css';

interface Props {
  menus: WordpressHeaderMenu[];
  podcast: WordpressArticlePage;
  adverts: KeyedAdverts;
  error?: any;
}

const Podcast = ({ podcast, menus, adverts }: Props) => {
  const children = (
    <div>
      {podcast?.podcastVideo?.youtubeUrl && (
        <div className='flex justify-center'>
          <iframe
            className={`${styles.video} my-8`}
            src={podcast.podcastVideo.youtubeUrl}
            frameBorder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
          ></iframe>
        </div>
      )}
      {podcast?.lowerPageContent?.content && (
        <div
          className='my-4'
          dangerouslySetInnerHTML={{
            __html: contentWpToCF(podcast.lowerPageContent.content)
          }}
        />
      )}
    </div>
  );

  return !podcast ? (
    <FourOhFour />
  ) : (
    <Article
      tags={podcast.tags.nodes}
      menus={menus}
      page={podcast}
      adverts={adverts}
      articleHasBeenSponsored={
        podcast.sponsorship.articleHasBeenSponsored === 'yes'
      }
      childrenBeforeAuthor={children}
    />
  );
};

Podcast.getInitialProps = async ({ query }: NextPageContext) => {
  const slug = Array.isArray(query.slug) ? query.slug[0] : query.slug;
  const { podcast } = await fetchPodcastByURI(slug);
  return { podcast };
};

export default pageWrapper(Podcast);
